import get from 'lodash/get'

const addressValidation = (state) => get(state, 'addressValidation')

export const isContinentalUs = (state) => get(addressValidation(state), 'isContinentalUs')
export const inputAddress = (state) => get(addressValidation(state), 'inputAddress')
export const isValid = (state) => get(addressValidation(state), 'isValid')
export const recommendedUpdates = (state) => get(addressValidation(state), 'recommendedUpdates')
